import {
  FormControl,
  Grid,
  Typography,
  Autocomplete,
  Chip,
  TextField
} from "@mui/material";
import { CustomStyledTextField } from "./ColoredTextfield";
import { AgMuiSelect } from "./AgMuiSelect";
import { useCallback, useEffect, useRef, useState } from "react";
import { Controller } from "react-hook-form";
import Api from "../state/Api";
import Newapi from "../state/new-api";
import Utils from "../util/Utils";
import { enquiryStore } from "../enquiry/enquiry-data";
import { AgMuiSelect2 } from "./Controlled";
import { AgmodalStore, quoteDataRec } from "../state/CommonState";
import { debounce } from "lodash";


export default function AgAutoComplete({ id, options, name, onChange,control, rules, onBlur, defaultValue, onInputChange, selectedValue, fontSize,disabled, ...restProps }) {
  // const [inputValue, setInputValue] = useState('');
  //  const [options,setOptions] = useState([]);

  //  const fetchSuggestions = async (input) => {
  //   try {
  //     setLoading(true);
  //     // const response = await ;
  //     setSuggestions(response.data);
  //   } catch (error) {
  //     console.error('Error fetching suggestions:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  //  const handleInputChange = (event, newValue) => {
  //   setInputValue(newValue);
  //   // if (newValue) {
  //   //   fetchSuggestions(newValue);
  //   // }
  // };
  // const [autocompleteOpen, setAutocompleteOpen] = useState(false);
  // useEffect(()=>{
  //    console.log("the options inside the ",options)
  //    if(options.length===0){
  //     // setAutocompleteOpen(false);
  //    }else{
  //     if(autocompleteOpen===false){
  //       setAutocompleteOpen(true);
  //     //  }else{
  //     //   setAutocompleteOpen(false);
  //     //   setAutocompleteOpen(true);
  //      }
  //    }
  // },[options])
  const errorshow = (msg)=>{
    return (id==undefined || id!=0 || (id==0 && msg!="Different countries not allowed."))?true:false
  }
  
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState }) => <Autocomplete
        disabled={disabled}
        value={field.value || null}
        inputValue={field.value || ''}
        freeSolo={true}
        size="small"
        filterOptions={(menuoptions, state) => menuoptions}
        onBlur={() => {
          if(fieldState.isTouched){
            if (onBlur) {
              onBlur(field.value);
            }
          }
        }}
        onChange={(e, val) => {
          const newVal = typeof val === 'string' ? val : (val?.label || val || '');
          field.onChange(newVal);
          if (selectedValue) {
            selectedValue(e, newVal);
          }
          if(onChange){
            onChange(newVal);
          }
        }}
        onInputChange={(e, newInputValue, reason) => {
          if (reason === 'input') {
            field.onChange(newInputValue);
          }
          if (onInputChange) {
            onInputChange(newInputValue !== undefined ? newInputValue : (e?.target?.value || ''));
          }
        }}
        disablePortal
        options={options}
        sx={{ width: "100%" }}
        renderInput={(params) => <CustomStyledTextField sx={{ "& .MuiOutlinedInput-root": {
          "&.Mui-focused": {
            fieldset: {
              borderColor:`${process.env.REACT_APP_ENTERPRISE_COLOUR} !important`,
            },
          },
        }}}  {...restProps} size="small" {...field} value={field.value || ''} error={errorshow(fieldState?.error?.message)?!!fieldState?.error:false} helperText={errorshow(fieldState?.error?.message)?fieldState?.error?.message:""} {...params} fullWidth  />}
      />}
    />
  );
}





export function AgMuiUn({ id, isFba=false,warehouse="AMAZON",getValues,doorCountry="", onChange,isDoor, validateAddress = false, rules,getFieldState, control, clearErrors, selectedValue,trigger, name,disabled,country=false, ...restProps }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    setOptions(() => []);
  }, [isDoor])

  // function checkcurrent() {
  //   if (record[name].length == 0) {
  //     return false
  //   } else {
  //     if (postcode.length == 0) {
  //       if (!Utils.checkAddress(record[name])) {
  //         return false
  //       } else {
  //         let a = record[name].split(' ')
  //         let l = false
  //         for (let i = 0; i < a.length; i++) {
  //           let k = a[i].replace(',', '').trim()
  //           if (Utils.checkZipcode(k)) {
  //             l = true
  //             i = a.length + 1
  //           }
  //         }
  //         if (!l) {
  //           let a = record[name].split(',')
  //           for (let i = 0; i < a.length; i++) {
  //             let k = a[i].trim()
  //             if (Utils.checkZipcode(k)) {
  //               l = true
  //               i = a.length + 1
  //             }
  //           }
  //         }
  //         if (!l) {
  //           return false
  //         } else {
  //           return true
  //         }
  //       }
  //     } else {
  //       return true
  //     }

  //   }
  // }




  const displaySuggestions = async function (val) {
    
    let product = "LCL"
    if(AgmodalStore.modalPage!=undefined && AgmodalStore.modalPage=="Quotev3"){
      if(quoteDataRec.shipmentType.toLowerCase().indexOf('fcl')!=-1) product = "FCL"
      if(quoteDataRec.shipmentType.toLowerCase().indexOf('air')!=-1) product = "Air"
    }else{
      if(enquiryStore.current.shipmentType.toLowerCase().indexOf('fcl')!=-1) product = "FCL"
      if(enquiryStore.current.shipmentType.toLowerCase().indexOf('air')!=-1) product = "Air"
          
    }
    if (val) {
      if(country){
        if(val.length > 2){
          Api.getMapUnloc({ descriptions: [val, product] }, (data) => {
            if(data?.length > 0) setOptions(data)
              else setOptions([])
          })
        }
      }else{
        if (val.length > 2) {
          let results = await Newapi.get(`${process.env.REACT_APP_API_SERVER}/api/v1/location/fetchlocation4product/${product}/${val}`)
          if (results.error) {
            setOptions([])
          } else {
            setOptions(results)
          }
        }
      }
    }
  };


  const getdata = async (inputValue) => {
    console.log("getdata------------------------------------------")
    if (inputValue && inputValue.length > 2) {
      let results
      let s = encodeURI(inputValue)
      let url = ""
      if(isFba){
        url = `${process.env.REACT_APP_API_SERVER}/api/v1/location/fetchaddressfba/${s}?warehouse=${warehouse}`
      }else{
        url = `${process.env.REACT_APP_API_SERVER}/api/v1/location/fetchaddress2/${encodeURIComponent(s)}`
      }
      results = await Newapi.get(url)
      return results;
    } else {
      return []
    }
  }

  function check(value) {
    let isError = false;
    if (value?.length > 0) {
      let l = Utils.getUNCodeFromLocationString(value);
      try {
        if (Utils.isUnLoc1(value)) {

          Api.checkUnloc(l, (data) => {
            isError = false;

            if (data == -1) {
              return
            } else {
              console.log("valid 2");
            }
          })
        } else {
          isError = true;

        }
      } catch (e) {
        console.log("the errror is ", e)
      }

    }
    if (isError) {
        return 'Please select an UN address'
    } else {
        return;
    }
  }

  const validateDoorAddress = (value,doorCountry) => {
    console.log("+##33",doorCountry)
    const getcountry =(d)=>{
      if(d!=undefined && d.trim().length!=0){
        d = d.split(',')
        if(d.length>0){
          return d[d.length-1]
        }
      }else{
        return ""
      }
    }
    if(value==undefined || value.trim().length==0 || value.split(",").length==1){
      return "Invalid Address"
    }else{
      if(doorCountry!=undefined && doorCountry!="" && id!=undefined && id!=0){
        let d = getcountry(doorCountry)
        let d1 = getcountry(value)
        if(d!=d1){
          return "Different countries not allowed."
        }else{
          return;
        }
      }else{
        return;
      }
    }
    let isError = false;
    let postcode = "";
    let startIndex = value?.indexOf("[");
    let endIndex = value?.indexOf("]");

  
    if(endIndex===-1){
      return "* Pin/code is required"
    }
    if (startIndex > -1) {
      postcode = value.substring(startIndex + 1, value.length - 1).split(",")[2];
      if (!postcode) {
        postcode = "";
      }
    }else{
      return "* Pin/code is required"
    }

    if (isDoor && validateAddress) {
      if (!value || value?.length === 0) {
        isError = true;
      } else {
        if (postcode.length === 0) {
          if (!Utils.checkAddress(value)) {
            isError = true;
          } else {
            let a = value.split(' ')
            let l = false
            for (let i = 0; i < a.length; i++) {
              let k = a[i].replace(',', '').trim()
              if (Utils.checkZipcode(k)) {
                l = true
                i = a.length + 1
              }
            }
            if (!l) {
              
              let a = value.split(',')
              for (let i = 0; i < a.length; i++) {
                let k = a[i].trim()
                if (Utils.checkZipcode(k)) {
                  l = true
                  i = a.length + 1
                }
              }
            }else{
              l = false
            }


            if (!l) {
              isError = true;
            } else {
              isError = false;
            }
          }
        } else {
          isError = false;
        }
      }
    }
    if (isError) {
        return "* Pin/code is required"
    } else {
        return;
    }
  }

  const handler = async (input) => {
    if (!isDoor) {
      displaySuggestions(input);
    }
    if (isDoor) {
      getdata(input).then((val) => {
        setOptions(val);
      })
    }
  }

   const debouncedCall = useCallback(debounce(handler,500),[isDoor,warehouse]);



  // return disabled ?  <div className="flex p-2 border-solid border-[#D4D4D4] border-1 w-full rounded-[5px] bg-[#F3F3F3] text-black">{getValues(name)}</div> : 
  return <AgAutoComplete id={id} onChange={onChange}  selectedValue={selectedValue} 
  disabled={disabled}
  onBlur={async(value) => {
     if(trigger){
        await trigger(name);
     }

  }}
   rules={{
    ...rules,
    validate: (value) => {
      //let {isTouched} = getFieldState(name)
      if (validateAddress) {
        if(!isDoor){
          let isSelectedFromDropDown = options.some((option)=>value===option);
          if(!isSelectedFromDropDown){
            if(value.indexOf('(') == -1 || value.indexOf(')') == -1){
              return "Invalid UN Location"
            }
          }
        }
        if (isDoor) {
          return validateDoorAddress(value,doorCountry);
        } else {
          return check(value)
        }
      }
    }
  }} onInputChange={debouncedCall} control={control} name={name} options={options} {...restProps} />
}

export function EmailTagsField({
  label,
  width,
  disabled,
  control,
  rules,
  name,
  labelStyle,
  callback,
  madatory = false,
  placeholder = "Enter Email",
  textfieldStyles,
  ...rest
}) {

  return (
    <FormControl sx={{ width: width || "100%", height: "100%", gap: 0 }}>
      <Controller
        control={control}
        name={name}
        rules={{
          ...rules,
        }}
        defaultValue={[]}
        render={({ field, fieldState }) => (
          <Grid container rowSpacing={label ? "4px" : 0}>

            {/* Label */}
            <Grid item xs={12}>
              <Typography
                style={{
                  textAlign: "start",
                  fontFamily: "Figtree",
                  ...labelStyle,
                }}
              >
                {madatory ? (
                  <>
                    {label}
                    <span style={{ color: "red", marginLeft: 4 }}>*</span>
                  </>
                ) : (
                  label
                )}
              </Typography>
            </Grid>

            {/* Input */}
            <Grid item xs={12}>
              <Autocomplete
                multiple
                freeSolo
                disabled={disabled}
                options={[]}
                value={field.value || []}
                onChange={(event, newValue) => {
                  const cleaned = newValue.map((v) => v.trim());
                  const uniqueValues = [...new Set(cleaned)];

                  field.onChange(uniqueValues);

                  if (callback) {
                    callback(uniqueValues);
                  }
                }}
                filterSelectedOptions
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      variant="outlined"
                      label={option}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={disabled?"":placeholder}
                    size="small"
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        padding: "0px !important",
                        paddingRight: "0px !important",
                        backgroundColor: "white",
                        ...textfieldStyles,
                        "&.Mui-focused fieldset": {
                          borderColor: `${process.env.REACT_APP_ENTERPRISE_COLOUR} !important`,
                        },
                        "&.Mui-error.Mui-focused fieldset": {
                          borderColor: "red !important",
                        },
                      },
                    }}
                    onKeyDown={(e) => {
                      // prevent arrow scroll
                      if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                        e.preventDefault();
                      }

                      // space support like old component
                      if ((e.key === "Enter" || e.key === "Tab") && e.target.value) {
                        e.preventDefault();
                        const newValue = [
                          ...(field.value || []),
                          e.target.value.trim(),
                        ];
                        const uniqueValues = [...new Set(newValue)];

                        field.onChange(uniqueValues);

                        if (callback) {
                          callback(uniqueValues);
                        }
                      }
                    }}
                  />
                )}
                {...rest}
              />
            </Grid>
          </Grid>
        )}
      />
    </FormControl>
  );
}
